import { render, staticRenderFns } from "./form-field.vue?vue&type=template&id=82f6d242&lang=pug"
import script from "./form-field.vue?vue&type=script&lang=ts"
export * from "./form-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports